<script>
export default {
  props: {
    kitData: {
      type: Object,
      required: true
    }
  }
};
</script>
<template>
  <div class="flex flex-row py-4">
    <div>
      <p>This is a kit - online only</p>
      <p>
        Price
        <b class="font-bold text-green-500">
          {{ kitData.price | currencyFormatted(true) }}
        </b>
      </p>
      <p>
        Price without discount
        <b class="font-bold text-red-300">
          {{ kitData.priceNoDiscount | currencyFormatted(true) }}
        </b>
      </p>
      <p>Stock {{ kitData.stock }}</p>
    </div>
    <div>
      <ul class="flex flex-col gap-1">
        <li
          v-for="item in kitData.items"
          :key="item.nkrCode"
          class="flex flex-row gap-2 items-center border border-gray-200 p-2 rounded-md"
        >
          <img :src="item.imageRoute" class="w-16" />
          <p>
            <b class="font-bold text-red-400">{{ item.quantity }}</b> X
            {{ item.nkrCode }} -
            <span class="text-red-500">{{ item.line }}</span> at ${{
              item.price
            }}
            ea
            <br />
            {{ item.name }}
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>
